/** Chemins qui ne doivent jamais servir de cible de redirection après connexion. */
const EXCLUDED_PREFIXES = ['/login', '/invitation/', '/connexion/']

/**
 * N'accepte qu'un chemin **interne** :
 * - commence par `/` mais pas par `//` ni `/\` (URL protocol-relative, ex. `//evil.tld`)
 * - n'est pas une page d'authentification (sinon on boucle après la connexion)
 *
 * Toute autre valeur est ignorée : l'utilisateur ira sur son accueil.
 */
export function sanitizeRedirect(value: unknown): string | undefined {
  if (typeof value !== 'string' || !/^\/(?![/\\])/.test(value)) return undefined

  const path = value.split(/[?#]/, 1)[0] ?? value
  if (EXCLUDED_PREFIXES.some((prefix) => path === prefix || path.startsWith(prefix))) {
    return undefined
  }
  return value
}

export interface LoginSearch {
  redirect: string | undefined
  /** 1.69.0 : `lien` ouvre directement « Recevoir un lien de connexion ». */
  mode?: 'lien' | undefined
}

/** Les paramètres de recherche de `/login` : une cible interne, ou rien. */
export function parseLoginSearch(search: Record<string, unknown>): LoginSearch {
  return {
    redirect: sanitizeRedirect(search.redirect),
    ...(search.mode === 'lien' ? { mode: 'lien' as const } : {}),
  }
}

/**
 * 1.69.0 : le `next_path` d'un lien de connexion — un chemin du portail
 * seulement, jamais une adresse d'ailleurs ; sinon rien.
 */
export function portalNextPath(value: unknown): string | undefined {
  const path = sanitizeRedirect(value)
  return path && (path === '/portal' || path.startsWith('/portal/')) ? path : undefined
}
